export function gainSpirit(current: number, amount: number): number {
  return current + amount;
}

export function spendSpirit(current: number, cost: number): number {
  return Math.max(0, current - cost);
}

export function canAfford(current: number, cost: number): boolean {
  return cost <= 0 || current >= cost;
}
